export const AUTHENTICATE_PASS = '0177940816';
